import BehamrahCoreApp from "@behamrah/behamrah-react-core/dist/App";

import config from "./config";

const App = () => (
  <>
    <BehamrahCoreApp config={config} />
  </>
);

export default App;
